import { cn } from '../../lib/cn';
import type { AutomatedTestRow } from '../../enterprisequality/framework';

type Props = { tests?: AutomatedTestRow[] };

export function AutomatedTestingPanel({ tests = [] }: Props) {
  return (
    <div className="space-y-2">
      {tests.map((t) => (
        <div key={t.suite} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{t.type}</p>
              <p className="text-xs text-slate-500">{t.suite}</p>
            </div>
            <div className="text-right">
              <p className={cn(
                'text-sm font-semibold',
                t.passed === t.total ? 'text-success-600' : 'text-warning-600',
              )}>
                {t.passed}/{t.total}
              </p>
              {t.coverage !== '—' && (
                <p className="text-xs text-slate-500">{t.coverage} coverage</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
